// extracted by mini-css-extract-plugin
module.exports = {"landing":"LandingPage_landing__Ge4EM","link":"LandingPage_link__1s_yZ","lightbutton":"LandingPage_lightbutton__3uX3W"};